import { checkIfEmptyCardsList } from '../../checkEmptyCards'
import getAllEntitiesSlugs from '../../get-all-entities-slugs'

export async function fetchEntities(slugs: string[]) {
  const entities = await getAllEntitiesSlugs(slugs)
  if (entities && !entities.error) {
    checkIfEmptyCardsList(entities.cards)
  }
  return entities
}
